import React from 'react';
import { FormattedMessage } from 'react-intl';
import messages from './messages';

import './styles.scss';

class RequestOffer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};

  }

  render() {

    return (
      <div id="RequestOffer">
        <div className="element-box">
          <div className="d-inline-block">
          <p className="text-medium text-bold">
            {messages.title.defaultMessage}
          </p>
            <FormattedMessage {...messages.description} />
          </div>
          <a href="/offer/request" className="request-button" aria-label={messages.action.defaultMessage}>
            {messages.action.defaultMessage}
          </a>
        </div>
      </div>
    );
  }
}

RequestOffer.propTypes = {};

export default RequestOffer;
